import { paramsHook } from 'external/deep-diff'
import { isUUID } from 'external/lodash'
import { isEmpty } from 'utilities/text'
import { accountingService } from 'services/accounting.service'
import { isLoggedInAndInRoute } from 'utilities/navigate'

const hooks = [
  {paths: paramsHook('pageName', '?pattern', '?pageSize', '?page', '?sortBy', '?from', '?to'), resolves: [fetchPayouts]},
  {paths: paramsHook('pageName', 'payoutId', 'payouts/refreshes/'), resolves: [fetchPayout]}
]

export {hooks as default}

export async function fetchPayouts({update, state}, {contexts}) {
  const userId = isLoggedInAndInRoute('accountingPayouts', {state, contexts})
  if (!isUUID(userId)) return
  const {props: {query: {pattern, sortBy, pageSize = 10, page = 1, from, to}}} = state
  update({payouts: {$startLoading: {}}, payoutsPaging: {$set: false}})
  const {data} = await accountingService.searchPayouts(userId, {pattern, sortBy, pageSize, page, from, to})
  const {results, paging} = data
  update({payouts: {$updateLoadableList: results}, payoutsPaging: {$set: paging}})
}

export async function fetchPayout({update, state}, {contexts}) {
  const userId = isLoggedInAndInRoute('accountingPayout', {state, contexts})
  if (!isUUID(userId)) return
  const {props: {params: {payoutId}}} = state
  if (isEmpty(payoutId)) return
  // Don't re-fetch if already loaded for this payoutId
  if (state.payout.id === payoutId && state.payout.data) return
  update({payout: {loading: {$set: true}, id: {$set: false}, data: {$set: false}}})
  const {data} = await accountingService.getPayoutDetail(userId, payoutId)
  update({payout: {loading: {$set: false}, id: {$set: payoutId}, data: {$set: data}}})
}